export default __webpack_public_path__ + "static/media/code-box.42600092.png";